<template>
  <div >
    <loader :show="enviando" />

      <b-col sm="12">
      <h4 style="text-align: center">1. DATOS GENERALES</h4>
      </b-col>    <b-row>
      <b-col md="4">
        <b-form-group>
          <label>NOMBRE(S)</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            v-model="generales.nombre"
            placeholder="NOMBRE"
            :class="{invalid_input: $v.generales.nombre.$error}"
          ></b-form-input>
          <label v-if="$v.generales.nombre.$error && !$v.generales.nombre.required" class="error-text"><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label >PRIMER APELLIDO</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.primerApellido"
            type="text"
            placeholder="APELLIDO PATERNO"
            :class="{invalid_input: $v.generales.primerApellido.$error}"
          ></b-form-input>
          <label v-if="$v.generales.primerApellido.$error && !$v.generales.primerApellido.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label >SEGUNDO APELLIDO</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.segundoApellido"
            type="text"
            placeholder="APELLIDO MATERNO"
            :class="{invalid_input: $v.generales.segundoApellido.$error}"
          ></b-form-input>
          <label v-if="$v.generales.segundoApellido.$error && !$v.generales.segundoApellido.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label >CURP</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.curp"
            type="text"
            placeholder="CURP"
            :class="{invalid_input: $v.generales.curp.$error}"
          ></b-form-input>
          <label v-if="$v.generales.curp.$error && !$v.generales.curp.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>RFC</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.rfc.rfc"
            placeholder="RFC"
          ></b-form-input>
          <label v-if="$v.generales.rfc.rfc.$error && !$v.generales.rfc.rfc.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <label >HOMOCLAVE</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="generales.rfc.homoClave"
            placeholder="HOMOCLAVE"
            :class="{invalid_input: $v.generales.rfc.homoClave.$error}"
          ></b-form-input>
          <label v-if="$v.generales.rfc.homoClave.$error && !$v.generales.rfc.homoClave.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label >CORREO ELECTRÓNICO INSTITUCIONAL</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.correoElectronico.institucional"
            type="text"
            placeholder="CORREO ELECTRÓNICO INSTITUCIONAL"
          
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>CORREO ELECTRÓNICO PERSONAL / ALTERNO</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.correoElectronico.personal"
            :class="{invalid_input: $v.generales.correoElectronico.personal.$error}"
            type="text"
            placeholder="CORREO ELECTRÓNICO PERSONAL / ALTERNO"
          ></b-form-input>
          <label v-if="$v.generales.correoElectronico.personal.$error && !$v.generales.correoElectronico.personal.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <label >ESTADO CIVIL</label>
          <b-form-select
            :disabled="status === 'Concluida'"
            @change="cambios = true, cualvalorES()"
            v-model="generales.situacionPersonalEstadoCivil.clave"
            @input="modificaRegimen = checaRegimen"
            :options="edoCivil"
          >           
            <!-- @input="(generales.situacionPersonalEstadoCivil.valor = (cualvalorES())),(modificaRegimen = checaRegimen)" -->
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group v-if="generales.situacionPersonalEstadoCivil.clave === 'CAS'">
          <label>RÉGIMEN MATRIMONIAL</label>
          <b-form-select
            :disabled="status === 'Concluida'"
            @change="cambios = true"
            @input="generales.regimenMatrimonial.valor = queRegimen"
            v-model="generales.regimenMatrimonial.clave"
            :options="regimen"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <label>PAÍS DE NACIMIENTO</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.paisNacimiento"
            type="text"
            placeholder="PAÍS DE NACIMIENTO"
            :class="{invalid_input: $v.generales.paisNacimiento.$error}"
          ></b-form-input>
          <label v-if="$v.generales.paisNacimiento.$error && !$v.generales.paisNacimiento.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <label>NACIONALIDD</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.nacionalidad"
            type="text"
            placeholder="NACIONALIDAD"
            :class="{invalid_input: $v.generales.nacionalidad.$error}"
          ></b-form-input>
          <label v-if="$v.generales.nacionalidad.$error && !$v.generales.nacionalidad.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>NÚMERO CELULAR PERSONAL</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.telefono.celularPersonal"
            type="text"
            placeholder="NÚMERO CELULAR PERSONAL"
            :class="{invalid_input: $v.generales.telefono.celularPersonal.$error}"
          ></b-form-input>
          <label v-if="$v.generales.telefono.celularPersonal.$error && !$v.generales.telefono.celularPersonal.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>NÚMERO TELEFÓNICO DE CASA</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="generales.telefono.casa"
            type="text"
            placeholder="NÚMERO TELEFÓNICO DE CASA"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="generales.aclaracionesObservaciones"
            placeholder="ACLARACIONES / OBSERVACIONES"
          ></b-form-input>
        </b-form-group>
      </b-col>

    <br />
    <br />
</b-row>
    <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>
      <b-col>
        <p v-if="cambios" class="error-text"> <i>No se han guardado los cambios</i></p>
      </b-col>
      <b-col >
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarSeccion()"
          :disabled="enviando"
        >Siguiente</b-button>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name:"datosGenerales",
  components: { Loader },
  props: ['generales','status'],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    checaRegimen() {
      if (this.generales.situacionPersonalEstadoCivil.clave !== "CAS") {
        this.generales.regimenMatrimonial.valor = null;
        return false;
      } else {
        this.generales.regimenMatrimonial.clave = "";
        this.generales.regimenMatrimonial.valor = "";
        return true;
      }
    }
  },
  validations:{

    generales:{
      nombre: {required},
      primerApellido: {required},
      segundoApellido: {required},
      curp: {required},
      rfc:{
        rfc: {required},
        homoClave: {required}
      },      
      correoElectronico:{
        personal: {required}
      },
      telefono:{
        celularPersonal: {required}
      },
      
      paisNacimiento: {required},
      nacionalidad: {required}
    }
  },
  data: function() {
    return {
      
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      edoCivil: [
        { value: "SOL", text: "SOLTERO (A)" },
        { value: "CAS", text: "CASADO (A)" },
        { value: "DIV", text: "DIVORCIADO (A)" },
        { value: "VIU", text: "VIUDO (A)" },
        { value: "CON", text: "CONCUBINA/CONCUBINARIO/UNIÓN LIBRE" },
        { value: "SCO", text: "SOCIEDAD DE CONVIVENCIA" }
      ],
      regimen: [
        { value: "SOC", text: "SOCIEDAD CONYUGAL" },
        { value: "SBI", text: "SEPARACIÓN DE BIENES" },
        { value: "OTR", text: "OTRO" }
      ],
      modificaRegimen: false
    };
  },
  created(){
    this.generales.situacionPersonalEstadoCivil.clave = this.generales.situacionPersonalEstadoCivil.clave ? this.generales.situacionPersonalEstadoCivil.clave : this.edoCivil[0].value;
    this.generales.situacionPersonalEstadoCivil.valor = this.generales.situacionPersonalEstadoCivil.valor ? this.generales.situacionPersonalEstadoCivil.valor : this.cualvalorES();
  },
  methods: {
    actualizarSeccion() {
      if(this.status!='Concluida'){
      this.$v.$touch();
      if(!this.$v.$invalid) {

        this.enviando = true;
        //console.log(this.generales);
        axios
          .put(this.httpURL + "/declaraciones/V2/datosGenerales/" + this.$route.params.id,
            {
              nombre: this.generales.nombre,
              primerApellido: this.generales.primerApellido,
              segundoApellido: this.generales.segundoApellido,
              curp: this.generales.curp,
              rfc: this.generales.rfc.rfc,
              rfcHomoclave: this.generales.rfc.homoClave,
              correoInstitucional: this.generales.correoElectronico.institucional,
              correoPersonal: this.generales.correoElectronico.personal,
              telefonoCasa: this.generales.telefono.casa,
              telefonoCelular: this.generales.telefono.celularPersonal,
              edoCivilClave: this.generales.situacionPersonalEstadoCivil.clave,
              edoCivilValor: this.generales.situacionPersonalEstadoCivil.valor,
              regimenMatrimonialClave: this.generales.regimenMatrimonial.clave,
              regimenMatrimonialValor: this.generales.regimenMatrimonial.valor,
              paisNacimiento: this.generales.paisNacimiento,
              nacionalidad: this.generales.nacionalidad,
              aclaracionesObservaciones: this.generales.aclaracionesObservaciones
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => { 
            //console.log(res);
            this.enviando = false;
            this.cambios = false;
            this.verSeccion(2)
            this.$notify({   type: "success",    duration: 2500,  speed: 1000,     text: res.data.mensaje });
          })
          .catch(error => {
            //console.log(////error);
            this.$notify({group: "foo",type: "error",duration: 2500,speed: 1000,text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      }
      }
      else{
        this.verSeccion(2)
      }
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    cualvalorES() {
      if (this.generales.situacionPersonalEstadoCivil.clave === "SOL") {
        this.generales.situacionPersonalEstadoCivil.valor="SOLTERO (A)";
      } else if (this.generales.situacionPersonalEstadoCivil.clave === "CAS") {

        this.generales.situacionPersonalEstadoCivil.valor= "CASADO (A)";
        this.generales.regimenMatrimonial.clave=this.regimen[0].value;
        this.queRegimen();
      } else if (this.generales.situacionPersonalEstadoCivil.clave === "DIV") {
        this.generales.situacionPersonalEstadoCivil.valor= "DIVORCIADO (A)";
      } else if (this.generales.situacionPersonalEstadoCivil.clave === "VIU") {
        this.generales.situacionPersonalEstadoCivil.valor= "VIUDO (A)";
      } else if (this.generales.situacionPersonalEstadoCivil.clave === "CON") {
        this.generales.situacionPersonalEstadoCivil.valor= "CONCUBINA/CONCUBINARIO/UNIÓN LIBRE";
      } else if (this.generales.situacionPersonalEstadoCivil.clave === "SCO") {
        this.generales.situacionPersonalEstadoCivil.valor= "SOCIEDAD DE CONVIVENCIA";
      }
    },
    queRegimen() {
      if (this.generales.regimenMatrimonial.clave === "SOC") {
        this.generales.regimenMatrimonial.valor= "SOCIEDAD CONYUGAL";
      } else if (this.generales.regimenMatrimonial.clave === "SBI") {
        this.generales.regimenMatrimonial.valor= "SEPARACIÓN DE BIENES";
      } else if (this.generales.regimenMatrimonial.clave === "OTR") {
        this.generales.regimenMatrimonial.valor= "OTRO";
      }
    },
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>